export class InboxMsg {
    id: number;
    tag: Object; //tagID
    text: string;
    location: string;
    created_at: string;
}